const CheckSVG = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 32C20.2435 32 24.3131 30.3143 27.3137 27.3137C30.3143 24.3131 32 20.2435 32 16C32 11.7565 30.3143 7.68687 27.3137 4.68629C24.3131 1.68571 20.2435 0 16 0C11.7565 0 7.68687 1.68571 4.68629 4.68629C1.68571 7.68687 0 11.7565 0 16C0 20.2435 1.68571 24.3131 4.68629 27.3137C7.68687 30.3143 11.7565 32 16 32ZM23.714 12.382C23.8298 12.2226 23.9131 12.0419 23.9591 11.8503C24.0051 11.6587 24.0129 11.4599 23.9821 11.2652C23.9513 11.0706 23.8824 10.884 23.7794 10.7159C23.6765 10.5479 23.5414 10.4018 23.382 10.286C23.2226 10.1702 23.0419 10.0869 22.8503 10.0409C22.6587 9.99488 22.4599 9.98707 22.2652 10.0179C22.0706 10.0487 21.884 10.1176 21.7159 10.2206C21.5479 10.3235 21.4018 10.4586 21.286 10.618L14.32 20.198L10.56 16.438C10.4216 16.2948 10.256 16.1806 10.0729 16.1021C9.88991 16.0236 9.69306 15.9823 9.49389 15.9806C9.29472 15.979 9.09722 16.017 8.91291 16.0926C8.7286 16.1681 8.56118 16.2795 8.42041 16.4204C8.27963 16.5613 8.16833 16.7289 8.093 16.9132C8.01766 17.0976 7.9798 17.2952 7.98163 17.4943C7.98345 17.6935 8.02492 17.8903 8.10362 18.0733C8.18232 18.2562 8.29667 18.4217 8.44 18.56L13.44 23.56C13.5933 23.7133 13.7779 23.8316 13.9813 23.9067C14.1847 23.9819 14.4019 24.012 14.618 23.9951C14.8342 23.9782 15.0441 23.9146 15.2333 23.8087C15.4225 23.7029 15.5865 23.5573 15.714 23.382L23.714 12.382Z"
        fill="#9ACF8B"
      />
    </svg>
  );
};
export default CheckSVG;
